import { Component } from 'react';
import { Row, Col, Select, Button, Typography, Divider } from 'antd';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { getMyBranches } from '../../services/api';
import { getRouteByBranch } from '../../services/route';
import { DownloadOutlined } from '@ant-design/icons';
import { exportCustomerExcel } from '../../services/customer';

const { Option } = Select;
const { Text } = Typography;

class ExportExcel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedBranchId: undefined,
            selectedRouteId: undefined,
            selectedBranch: {},
            selectedRoute: {},
            dataLoading: false,
            branchChoices: [],
            routeChoices: []
        }
        this.getBranchChoices = this.getBranchChoices.bind(this)
        this.getRouteChoices = this.getRouteChoices.bind(this)
        this.onExportCustomerExcelClicked = this.onExportCustomerExcelClicked.bind(this)
    }

    async getBranchChoices() {
        const res = await getMyBranches()
        const branchChoices = res.data.user_branches.map(ub => ub.branch)
        this.setState({
            branchChoices
        })
    }
    async getRouteChoices(branchId) {
        // set selected branch
        const { branchChoices } = this.state
        let branch;
        for (let i=0; i<branchChoices.length; i++){
            if (branchChoices[i].id === branchId){
                branch = branchChoices[i]
                break
            }
        }
        this.setState({
            selectedBranchId: branchId,
            selectedBranch: branch
        }, async () => {
            const res = await getRouteByBranch([branchId])
            this.setState({
                routeChoices: res.data.routes,
                selectedRouteId: undefined
            })
        })
        
    }

    async onRouteSelected(routeId) {
        const { routeChoices } = this.state;
        let route;
        for (let i=0; i<routeChoices.length; i++){
            if (routeChoices[i].id === routeId){
                route = routeChoices[i]
                break
            }
        }
        this.setState({ 
            selectedRoute: route,
            selectedRouteId: routeId 
        })
    }

    async componentDidMount() {
        const { profile } = this.props
        await this.getBranchChoices()
        await this.setState({
            selectedBranchId: profile.profile.current_branch.id
        })
        await this.getRouteChoices(profile.profile.current_branch.id)
    }

    async onExportCustomerExcelClicked() {
        const { selectedBranchId, selectedRouteId, selectedBranch, selectedRoute } = this.state
        await exportCustomerExcel(selectedBranchId, selectedRouteId, selectedBranch.name, selectedRoute.name)
    }


    render() {
        const { selectedBranchId, selectedRouteId, branchChoices, routeChoices, selectedBranch } = this.state
        const { profile } = this.props
        return <div>
                <Divider orientation="center">Excel ข้อมูลลูกค้า และถัง</Divider>
                <Row>
                {profile.profile.role === "ADMIN" ? 
                    <>
                    <Col span={2}></Col>
                    <Col span={8}>
                        <Select
                            allowClear
                            value={selectedBranchId}
                            style={{ width: '100%', marginBottom: 10 }}
                            placeholder="เลือกสาขา"
                            optionFilterProp="children"
                            onSelect={e => this.getRouteChoices(e)}
                            onClear={e => this.setState({selectedBranchId: undefined, selectedBranch: {}, selectedRouteId: undefined, selectedRoute: {}})}
                        >
                            {branchChoices.map(bc =>
                                <Option key={bc.id} value={bc.id}>{bc.code} {bc.name}</Option>
                            )}
                        </Select>
                    </Col>
                    <Col span={2}></Col>
                    <Col span={8}>
                        <Select
                            allowClear
                            value={selectedRouteId}
                            style={{ width: '100%', marginBottom: 10 }}
                            placeholder="เลือกสายบริการ"
                            optionFilterProp="children"
                            onSelect={e => this.onRouteSelected(e)}
                            onClear={e => this.setState({selectedRouteId: undefined, selectedRoute: {}})}
                            disabled={selectedBranchId === undefined}
                        >
                            {routeChoices.map(rc =>
                                <Option key={rc.id} value={rc.id}>{rc.name}</Option>
                            )}
                        </Select>
                    </Col>
                    <Col span={2}></Col>
                        </> :
                            <>
                                <Col span={6}></Col>
                                <Col span={10}>
                                    <Select
                                        allowClear
                                        value={selectedRouteId}
                                        style={{ width: '100%', marginBottom: 10 }}
                                        placeholder="เลือกสายบริการ"
                                        optionFilterProp="children"
                                        onSelect={e => this.onRouteSelected(e)}
                                        onClear={e => this.setState({selectedRouteId: undefined, selectedRoute: {}})}
                                        disabled={selectedBranchId === undefined}
                                    >
                                        {routeChoices.map(rc =>
                                            <Option key={rc.id} value={rc.id}>{rc.name}</Option>
                                        )}
                                    </Select>
                                </Col>
                                <Col span={6}></Col>
                            </>
                    }
                    <Col span={2}>
                        <Button
                            style={{ float: 'right' }}
                            type="primary"
                            icon={<DownloadOutlined />}
                            onClick={() => this.onExportCustomerExcelClicked()}
                        />
                    </Col>
                </Row>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        profile: state.profile
    };
}

export default withRouter((connect(mapStateToProps)(ExportExcel)));
